export default __webpack_public_path__ + "static/flex-1ec2c4753e02529c70ccd00a6b0d3797.png";